module.exports = __webpack_public_path__ + "media/virtualStaging/galleryImage5-23857f17.jpeg";